import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class WaitingList {
    constructor() {
		this.target = document.querySelector('[data-waiting-list="element"]');
        this.opened = false;
        this.events = {
            open(data) {
                return new CustomEvent('openWaitingList', {detail: data});
            },
            close() {
                return new CustomEvent('closeWaitingList');
            }
        }

        if ( null === this.target ) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.target.querySelectorAll('[data-waiting-list="close"]').forEach((trigger) => {
            trigger.addEventListener('click', () => {
                window.dispatchEvent(this.events.close());
            })
        });

		window.addEventListener('openWaitingList', (e) => {
            this.openModal(e);
		});

        window.addEventListener('closeWaitingList', (e) => {
            this.closeModal(e);
		});
	}

    openModal(e) {
        const modalTitle = this.target.querySelector('[data-title]');
        const modalTitleTemplate = modalTitle.getAttribute( 'data-title' );
        const inputNumber = this.target.querySelector('[name="number"]');
        const modalCTA = this.target.querySelector('[data-cta]');

        modalTitle.innerHTML = modalTitleTemplate.replace('%s', e.detail.number);
        inputNumber.value = e.detail.id;
        modalCTA.href = e.detail.url;

        this.target.classList.add('opened');
		document.body.classList.add('modal-opened');

        disableBodyScroll(this.target.querySelector('[data-waiting-list="window"]'))
    }

    closeModal(e) { 
        this.target.classList.remove('opened');
		document.body.classList.remove('modal-opened');

        clearAllBodyScrollLocks();
    }
}